import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/carousel-1.jpg'
import _imports_1 from '@/assets/images/carousel-2.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-3" }, "Slides Only & Auto", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, [
        _createTextVNode(" Use "),
        _createElementVNode("span", { class: "text-danger" }, "slide"),
        _createTextVNode(" class to set carousel with slides. Note the presence of the "),
        _createElementVNode("span", { class: "text-danger" }, "d-block"),
        _createTextVNode(" and "),
        _createElementVNode("span", { class: "text-danger" }, "w-100"),
        _createTextVNode(" class on carousel images to prevent browser default image alignment. ")
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4 mt-4",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", {
            id: "carouselExampleSlidesOnly",
            class: "carousel slide",
            "data-bs-ride": "carousel"
          }, [
            _createElementVNode("div", { class: "carousel-inner" }, [
              _createElementVNode("div", { class: "carousel-item active" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "d-block w-100",
                  alt: "carousel"
                })
              ]),
              _createElementVNode("div", { class: "carousel-item" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "d-block w-100",
                  alt: "carousel"
                })
              ])
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "codeCopy"
            }, "\n<div id=\"carouselExampleSlidesOnly\" class=\"carousel slide\" data-bs-ride=\"carousel\">\n<div class=\"carousel-inner\">\n<div class=\"carousel-item active\">\n<img src=\"@/assets/images/carousel-1.jpg\" class=\"d-block w-100\" alt=\"carousel\">\n</div>\n<div class=\"carousel-item\">\n<img src=\"@/assets/images/carousel-2.jpg\" class=\"d-block w-100\" alt=\"carousel\">\n</div>\n</div>\n</div>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}